/* ==========================================================================
   Life in 3D – RNR Redesign — product.js
   Variant selection (no page refresh), gallery, zoom, recently viewed store.
   ========================================================================== */

(function () {
  'use strict';

  const productJsonEl = document.querySelector('[data-product-json]');
  if (!productJsonEl) return;

  let productData;
  try {
    productData = JSON.parse(productJsonEl.textContent);
  } catch (e) {
    return;
  }

  const section = productJsonEl.closest('section');
  const picker = section.querySelector('[data-variant-picker]');
  const priceWrapper = section.querySelector('[data-price-wrapper]');
  const variantIdInput = section.querySelector('[data-variant-id]');
  const addToCartBtn = section.querySelector('[data-add-to-cart]');
  const addToCartText = section.querySelector('[data-add-to-cart-text]');
  const inventoryEl = section.querySelector('[data-inventory]');
  const stickyPrice = section.querySelector('[data-sticky-price]');
  const gallery = section.querySelector('[data-product-gallery]');

  const strings = window.theme.strings || {};

  /* ---------------------------- Gallery ---------------------------- */

  function setActiveMedia(mediaId) {
    if (!gallery) return;
    gallery.querySelectorAll('.product-gallery__slide').forEach((slide) => {
      slide.classList.toggle('is-active', slide.dataset.mediaId === String(mediaId));
    });
    gallery.querySelectorAll('.product-gallery__thumb').forEach((thumb) => {
      const active = thumb.dataset.thumbFor === String(mediaId);
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  if (gallery) {
    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('.product-gallery__thumb');
      if (thumb) setActiveMedia(thumb.dataset.thumbFor);

      const zoomTrigger = event.target.closest('[data-zoom-trigger], .product-gallery__zoom-trigger');
      if (zoomTrigger && zoomTrigger.dataset.zoomSrc) {
        const zoomImage = document.querySelector('[data-zoom-image]');
        if (zoomImage) zoomImage.src = zoomTrigger.dataset.zoomSrc;
      }
    });
  }

  /* ------------------------ Variant selection ----------------------- */

  function getSelectedOptions() {
    const options = [];
    if (!picker) return options;
    picker.querySelectorAll('fieldset').forEach((fieldset) => {
      const checked = fieldset.querySelector('input:checked');
      options.push(checked ? checked.value : null);
    });
    return options;
  }

  function findVariant(options) {
    return productData.variants.find((variant) =>
      variant.options.every((value, index) => value === options[index])
    );
  }

  function formatMoney(cents) {
    return window.theme.formatMoney ? window.theme.formatMoney(cents) : `$${(cents / 100).toFixed(2)}`;
  }

  function updateUI(variant) {
    if (!variant) {
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        if (addToCartText) addToCartText.textContent = strings.unavailable || 'Unavailable';
      }
      return;
    }

    if (variantIdInput) variantIdInput.value = variant.id;

    /* Price */
    if (priceWrapper) {
      let html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = `<div class="price price--large"><span class="price__sale">${formatMoney(variant.price)}</span> <s class="price__compare">${formatMoney(variant.compare_at_price)}</s> <span class="badge badge--sale">${strings.onSale || 'Sale'}</span></div>`;
      } else {
        html = `<div class="price price--large">${formatMoney(variant.price)}</div>`;
      }
      priceWrapper.innerHTML = html;
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    /* Buttons */
    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      if (addToCartText) {
        addToCartText.textContent = variant.available
          ? strings.addToCart || 'Add to cart'
          : strings.soldOut || 'Sold out';
      }
    }

    /* Inventory indicator: basic available/unavailable only (quantity requires re-render) */
    if (inventoryEl) {
      const dot = inventoryEl.querySelector('.inventory-dot');
      if (dot) {
        dot.classList.toggle('inventory-dot--out', !variant.available);
        dot.classList.remove('inventory-dot--low');
      }
      const label = variant.available ? strings.inStock || 'In stock' : strings.soldOut || 'Sold out';
      inventoryEl.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length) node.textContent = ` ${label}`;
      });
    }

    /* Selected value labels */
    if (picker) {
      picker.querySelectorAll('fieldset').forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        const label = fieldset.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
      });
    }

    /* Gallery */
    if (variant.featured_media && variant.featured_media.id) {
      setActiveMedia(variant.featured_media.id);
    }

    /* URL */
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  if (picker) {
    picker.addEventListener('change', () => {
      updateUI(findVariant(getSelectedOptions()));
    });
  }

  /* ------------------------- Recently viewed ------------------------ */

  try {
    const KEY = 'l3d:recently-viewed';
    const list = JSON.parse(localStorage.getItem(KEY) || '[]').filter((h) => h !== productData.handle);
    list.unshift(productData.handle);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
  } catch (e) {
    /* localStorage unavailable — ignore */
  }
})();
